import { motion } from "framer-motion";
import { FOCUS } from "@/constants/siteData";

const PARAGRAPHS = [
  "Stoyga tells non-fiction stories from India and South East Asia — stories that deserve the kind of care, time, and craft that only comes from a team built to make them.",
  "We work closely with the directors we collaborate with, treating every project as a long-term creative partnership rather than a one-off job. It's an approach rooted in genuine connection, patience, and a shared belief in the stories we're telling — the same values we bring to every story we help bring to the world.",
];

export const Manifesto = () => {
  return (
    <section id="about" className="relative border-t-2 border-border py-24 sm:py-32">
      <div className="container-xl">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4"
          >
            <span className="eyebrow-mono">// Studio Identity</span>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-foreground sm:text-4xl">
              Long-form.
              <br />
              On purpose.
            </h2>

            <div className="mt-8 inline-flex items-center border-2 border-foreground px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-foreground">
              {FOCUS}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-7 lg:col-start-6"
          >
            <div className="space-y-6 text-lg leading-relaxed text-foreground/80 sm:text-xl">
              {PARAGRAPHS.map((p, i) => (
                <p key={i} className={i === 0 ? "text-foreground" : ""}>
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-10 flex items-center gap-4 border-t-2 border-border pt-6">
              <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-muted-foreground">
                Stories From India &amp; South East Asia
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
